module.exports = __webpack_public_path__ + "img/loginimg.1fc14f51.png";